import { useNavigate } from "react-router-dom";
import { ReceivedEInvoicesPage as ReceivedEInvoicesPageView } from "@/components/ReceivedEInvoices";

export function ReceivedEInvoicesPage() {
  const navigate = useNavigate();

  // The component is router-agnostic; this wrapper supplies navigation.
  return <ReceivedEInvoicesPageView onDocumentClick={(href) => navigate(href)} />;
}
